import { defineAsyncComponent } from 'vue';

const DisplayUserTooltipGlobal = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/components/display-users/DisplayUserTooltipGlobal.vue')
);
const ColumnConfigPopover = defineAsyncComponent(() => {
  import(/*webpackChunkName:'settinglayout'*/ '@/views/task/Popovers/ColumnConfigPopover.vue')
})
// Đăng ký các popover vào đây
export function registerCommonPopover(app) {
  app.component('DisplayUserTooltipGlobal', DisplayUserTooltipGlobal);
  app.component('ColumnConfigPopover', ColumnConfigPopover);
}
